/**
 * A custom React hook that determines if the code is running in a
 * client-side environment.
 *
 * This hook returns a boolean value indicating whether the component is
 * being rendered on the client side (browser) or server side. It
 * initially returns false and then updates to true after the component
 * has mounted on the client, using a useEffect with an empty dependency
 * array.
 *
 * @returns {boolean} isClient - True if the code is running in a
 * client-side environment, false otherwise.
 *
 * @example
 * ```tsx
 * const YourComponent = () => {
 *   const isClient = useIsClient();
 *
 *   return (
 *     <div>
 *       {isClient ? 'Rendered on client' : 'Rendered on server'}
 *     </div>
 *   );
 * }
 * ```
 */
import { useEffect, useState } from "react";

export function useIsClient() {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient;
}
